import React from "react";
import { Link } from "react-router-dom";

export default function AboutHeader({ active }) {
  return (
    <nav className="container">
      <div
        className="nav nav-tabs justify-content-center"
        id="nav-tab"
        role="tablist"
      >
        <Link
          className={
            active === "whoweare"
              ? `nav-item nav-link nav-link-emg active`
              : `nav-item nav-link nav-link-emg`
          }
          to="/about/whoweare"
        >
          WHO WE ARE
        </Link>
        <Link
          className={
            active === "governance"
              ? `nav-item nav-link nav-link-emg active`
              : `nav-item nav-link nav-link-emg`
          }
          to="/about/governance"
        >
          GOVERNANCE
        </Link>
        <Link
          className={
            active === "strategicvision"
              ? `nav-item nav-link nav-link-emg active`
              : `nav-item nav-link nav-link-emg`
          }
          to="/about/strategicvision"
        >
          STRATEGIC VISION
        </Link>
        <Link
          className={
            active === "qualityandpermits"
              ? `nav-item nav-link nav-link-emg active`
              : `nav-item nav-link nav-link-emg`
          }
          to="/about/qualityandpermits"
        >
          QUALITY AND RESPONSIBILITY
        </Link>

        <Link
          className={
            active === "partners"
              ? `nav-item nav-link nav-link-emg active`
              : `nav-item nav-link nav-link-emg`
          }
          to="/about/partners"
        >
          PARTNERS
        </Link>
        <Link
          className={
            active === "trainings"
              ? `nav-item nav-link nav-link-emg active`
              : `nav-item nav-link nav-link-emg`
          }
          to="/about/training"
        >
          TRAININGS
        </Link>
        <Link
          className={
            active === "certificates"
              ? `nav-item nav-link nav-link-emg active`
              : `nav-item nav-link nav-link-emg`
          }
          to="/about/certificates"
        >
          CERTIFICATES
        </Link>
        <Link
          className={
            active === "branches"
              ? `nav-item nav-link nav-link-emg active`
              : `nav-item nav-link nav-link-emg`
          }
          to="/about/branches"
        >
          BRANCHES
        </Link>
      </div>
    </nav>
  );
}
